import React, { useState } from 'react';
import { useAuth } from './context/AuthContext';

import LandingPage from './pages/LandingPage';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Dashboard from './components/Dashboard';
import KanbanBoard from './components/KanbanBoard';
import Contacts from './components/Contacts';
import Activities from './components/Activities';
import Campaigns from './components/Campaigns';
import Settings from './components/Settings';
import DataHub from './components/DataHub';

function App() {
  const { user } = useAuth();
  const [currentView, setCurrentView] = useState('dashboard');

  // Si no hay usuario logueado, muestra la Landing Page pública
  if (!user) {
    return <LandingPage />;
  }

  // Enrutador interno del CRM basado en estados
  const renderView = () => {
    switch (currentView) {
      case 'dashboard':
        return <Dashboard />;
      case 'pipeline':
        return <KanbanBoard />;
      case 'contacts':
        return <Contacts />;
      case 'activities':
        return <Activities />;
      case 'campaigns':
        return <Campaigns />;
      case 'datahub':
        return <DataHub />;
      case 'settings':
        return <Settings />;
      default:
        return (
          <div className="animate-fade-in" style={{ textAlign: 'center', marginTop: '4rem' }}>
            <h2>Vista en Construcción</h2>
            <p className="text-muted" style={{ marginTop: '1rem' }}>Esta sección ({currentView}) estará disponible próximamente.</p>
          </div>
        );
    }
  };

  return (
    <div className="app-container animate-fade-in">
      {/* Layout Privado del CRM */}
      <Sidebar currentView={currentView} setCurrentView={setCurrentView} />
      
      <main className="main-content">
        <Topbar />
        
        <div className="page-content">
          {renderView()}
        </div>
        <footer style={{ marginTop: '1rem', padding: '1rem', textAlign: 'center', fontSize: '0.75rem', color: '#94a3b8', borderTop: '1px solid var(--border)' }}>
          &copy; 2026 VeritasVas.<br/>
          Software SaaS desarrollado por el Área de Informática de Veritas Vas.
        </footer>
      </main>
    </div>
  );
}

export default App;
